import {Graphics} from "pixi.js";
import {inches} from "../const";

// dash and gap lengths of a dashed outline (scene units).
const DASH = inches;
const DASH_GAP = 0.5 * inches;

// strokes a dashed rectangle outline; the current lineStyle is used for the dashes.
export function drawDashedRect(g: Graphics, x: number, y: number, w: number, h: number) {
    drawDashedPolygon(g, [{x, y}, {x: x + w, y}, {x: x + w, y: y + h}, {x, y: y + h}]);
}

// strokes a closed dashed outline through `points`; the current lineStyle is used.
export function drawDashedPolygon(g: Graphics, points: {x: number; y: number}[]) {
    for(let i = 0; i < points.length; i++) {
        const a = points[i];
        const b = points[(i + 1) % points.length];
        drawDashedLine(g, a.x, a.y, b.x, b.y);
    }
}

export function drawDashedLine(g: Graphics, x1: number, y1: number, x2: number, y2: number) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    const len = Math.hypot(dx, dy);
    if (len === 0) return;

    const ux = dx / len;
    const uy = dy / len;

    for (let dist = 0; dist < len; dist += DASH + DASH_GAP) {
        const end = Math.min(dist + DASH, len);
        g.moveTo(x1 + ux * dist, y1 + uy * dist);
        g.lineTo(x1 + ux * end, y1 + uy * end);
    }
}
